import React, { useState, useEffect } from "react"
import _ from "lodash"

import "./RoundProgress.scss"

interface IRoundProgress {
  currentQuestionNumber: number,
  numTotalQuestions?: number
}

const RoundProgress: React.FC<IRoundProgress> = ({currentQuestionNumber, numTotalQuestions}) => {
  const [ aniPerc, setAniPerc ] = useState(.0)

  useEffect(() => {
    let mounted = true
    let waitFrames = 0
    let animationFrame: number
    const moveCloser = () => {
      if (mounted) {
        setAniPerc((curPerc) => {
          if (waitFrames > 0) {
            waitFrames--
            animationFrame = window.requestAnimationFrame(moveCloser)
            return curPerc
          } else {
            let newPerc = curPerc + (1 - curPerc) * .035
            if (newPerc > .999) {
              newPerc = 1
            } else {
              animationFrame = window.requestAnimationFrame(moveCloser)
            }
            return newPerc
          }
        })
      }
    }
    moveCloser()

    return () => { // cleanup
      window.cancelAnimationFrame(animationFrame)
      mounted = false
    }
  }, [])

  let hasBar = false
  let barLeftRot = 0
  let barRightRot = 0
  if (_.isNumber(numTotalQuestions) && numTotalQuestions > 0) {
    hasBar = true
    const perc = (currentQuestionNumber / numTotalQuestions) * 100 * aniPerc
    // left
    if (perc <= 0) {
      barLeftRot = 0
    } else if (perc >= 50) {
      barLeftRot = 180
    } else {
      barLeftRot = ((perc / 50) * 180)
    }
    // right
    if (perc <= 50) {
      barRightRot = 0
    } else if (perc >= 100) {
      barRightRot = 180
    } else {
      barRightRot = (((perc - 50) / 50) * 180)
    }
  }

  return (
    <div className="neo__quizRoundProgress">
      {hasBar && <div className="neo__quizRoundProgress__bar">
        <div className="neo__quizRoundProgress__bar__left">
          <div className="neo__quizRoundProgress__bar__fillHolder" style={{transform: `rotate(${barLeftRot}deg)`}}>
            <div className="neo__quizRoundProgress__bar__fill"/>
          </div>
        </div>
        <div className="neo__quizRoundProgress__bar__right">
        <div className="neo__quizRoundProgress__bar__fillHolder" style={{transform: `rotate(${barRightRot}deg)`}}>
            <div className="neo__quizRoundProgress__bar__fill"/>
          </div>
        </div>
      </div>}
      <div className="neo__quizRoundProgress__numberHolder">
        <div>
          {_.isNumber(numTotalQuestions) && <span>/{" "}{numTotalQuestions}</span>}
          <strong className={currentQuestionNumber >= 10 ? "--smaller" : undefined}>{currentQuestionNumber}</strong>
          {_.isNumber(numTotalQuestions) && <span>/{" "}{numTotalQuestions}</span>}
        </div>
      </div>
    </div>
  )
}

export default RoundProgress
